const Path = {
  otp: '/otp',
  register: '/register',
  logs: '/logs',
  forgot_password: '/forgot-password',
  login: '/login',
  set_password: '/set-password',
  invalid_user: '/invalid-user',
  reset_password: '/reset-password',
  logOut: '/logout',
  lead_management: '/lead-management',
  lead: '/lead-management/lead',
  lead_details: '/lead-management/lead/lead-details',
  loan_application: '/loan-application',
  master: '/masters',
  loan_search: '/loan-search',
  loan_search_detail: '/loan-search/details',
  configuration: '/configuration',
  platform_management: '/platform-management',
  platform: '/platform-management/platform',
  platform_view: '/platform-management/platform/platform-view',
  platform_management_details: '/platform-management/platform/platform-details',
  mcc_management: '/mcc-management',
  mcc: '/mcc-management/mcc',
  mcc_management_details: '/mcc-management/mcc/mcc-details',
  loan_qde: '/loan-application/qde',
  loan_applicant: '/loan-application/qde/applicants',
  loan_application_details: '/loan-management/loan/loan-details',
  loan_application_reject: '/loan-application/rejected-applications',
  help: '/help',
  loan_management: '/loan-management',
  loan_dde: '/loan-application/dde',
  loan_dde_applicant: '/loan-application/dde/applicants',
  loan_onhold_applicant: '/loan-application/onhold/applicants',
  loan_rejected_application:
    '/loan-application/rejected-applications/applicants',
  loan_fi: '/loan-application/field-investigation',
  loan_review_fi: '/loan-application/review-fi',
  loan_disbursement: '/loan-application/disbursement',
  loan_personal_discussion: '/loan-application/personal-discussion',
  loan_onhold: '/loan-application/onhold',
  loan_conversation: '/loan-application/conversation',
  loan_conversation_applicant: '/loan-application/conversation/applicants',
  loan_disbursement_applicant: '/loan-application/disbursement/applicants',
  loan_fi_applicant: '/loan-application/field-investigation/applicants',
  loan_review_fi_applicant: '/loan-application/review-fi/applicants',
  loan_personal_dis_applicant:
    '/loan-application/personal-discussion/applicants',
  loan_eligibility: '/loan-application/eligibilty-check',
  loan_eligibility_applicant: '/loan-application/eligibilty-check/applicants',
  loan_approval_flow: '/loan-application/approval-flow',
  loan_approval_flow_applicant: '/loan-application/approval-flow/applicants',
  loan_loan_booking: '/loan-application/loan-booking',
  loan_loan_booking_applicant: '/loan-application/loan-booking/applicants',
  loan_document_esign: '/loan-application/document-esign',
  loan_document_esign_applicant: '/loan-application/document-esign/applicants',
  loan_document_verify: '/loan-application/document-verification',
  loan_document_verify_applicant:
    '/loan-application/document-verification/applicants',
  loan_partner_approval: '/loan-application/partner-approval',
  loan_partner_approval_appli: '/loan-application/partner-approval/applicants',
  loan_order_con: '/loan-application/order-confirmation',
  loan_order_con_applicant: '/loan-application/order-confirmation/applicants',
  masters_role_master: '/masters/role-master',
  masters_branch_master: '/masters/branch-master',
  masters_state_master: '/masters/state-master',
  masters_user_master: '/masters/user-master',
  masters_loan_product_master: '/masters/loan-product-master',
  masters_pincode_master: '/masters/pincode-master',
  masters_bank_branch_master: '/masters/bank-branch-master',
  masters_role_and_report_master: '/masters/role-reports-master',
  masters_branch_product_master: '/masters/branch-to-product-master',
  masters_co_lending_master: '/masters/co-lending-master',
  masters_consumer_master: '/masters/consumer-durable-master',
  api_logs: '/logs/api-log',
  loan_app_logs: '/logs/loan-application-log',
  loan_app_logs_detail: '/logs/loan-application-log/details',
  manage_reassign: '/manage-reassignment',
  reports: '/reports',
  manage_reassign_detail: '/manage-reassignment/detailed-view',
  notification: '/notification',
  profile: '/profile',
  template_engine: '/template-engine',
  customer360: '/customer-360',
};

export default Path;
